import React from 'react';
import { gql } from '@apollo/client';
import { Datagrid, FunctionField, ReferenceField, TextField } from 'react-admin';
import List from 'components/List';
import IdField from 'components/IdField';
import LinkField from 'components/LinkField';
import { scopeLabel } from 'utils/hrisMappingHelpers';

const HrisPositionMappingList = () => (
  <List exporter={false}>
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <IdField />
      <ReferenceField
        label="Company"
        source="company_id"
        reference="Company"
        link="show"
        sortable={false}
      >
        <TextField source="name" />
      </ReferenceField>
      <FunctionField label="Scope" render={scopeLabel} />
      <ReferenceField
        label="Location"
        source="location_id"
        reference="Location"
        link="show"
        sortable={false}
        emptyText="-"
      >
        <TextField source="name" />
      </ReferenceField>
      <LinkField label="Position" source="position.display_name" sortable={false} />
      <TextField label="External ID" source="external_id" sortable={false} />
    </Datagrid>
  </List>
);

HrisPositionMappingList.query = gql`
  query hrisPositionMappings($input: HrisPositionMappingQueryInput) {
    _hrisPositionMappingsMeta(input: $input) {
      count
    }
    hrisPositionMappings(input: $input) {
      id
      company_id
      location_id
      external_id
      position {
        id
        display_name
      }
    }
  }
`;

export default HrisPositionMappingList;
